/**
 * @generated SignedSource<<a0a2b45dc267233431ef94442c77ed5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = {
  "kind": "InlineDataFragment",
  "name": "hooksRemoveReadingHistoryArticle"
};
node.hash = "9cf9cb93788ef385dc0937902f020c9b";
export default node;